var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNoTecnicas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.398 25.1882C27.913 22.6224 29.4626 19.1096 29.4626 15.2323C29.4626 7.37185 23.0907 1 15.2303 1C7.36981 1 1 7.37185 1 15.2323C1 23.0928 7.37184 29.4647 15.2303 29.4647C16.2424 29.4647 17.23 29.3567 18.183 29.1572L25.398 33L25.4 25.1882H25.398Z",
    fill: "white",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4753 14.937C26.4753 21.148 21.4413 26.1819 15.2303 26.1819C9.0193 26.1819 3.98535 21.148 3.98535 14.937C3.98535 8.72597 9.0193 3.69202 15.2303 3.69202C21.4413 3.69202 26.4753 8.72597 26.4753 14.937Z",
    fill: "#EAF7F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06055 15.7841H10.4448L12.9393 9.66272L16.0754 20.6083C16.0163 20.4658 17.0488 15.4176 17.0488 15.4176L24.1334 15.389",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6879,
    cy: 14.8341,
    r: 3.61415,
    fill: "#F9839A",
    stroke: "#228C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoTecnicas);
export default __webpack_public_path__ + "static/media/Ic_NoTecnicas.b02c128e61d0f95ab608765f956c2ae5.svg";
export { ForwardRef as ReactComponent };